import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import inlineStyles from './ParkedReceipts.styles';
import { CircularProgress } from '@material-ui/core';
import { IParkedReceiptsProps } from './ParkedReceipts.properties';
import DataList from 'components/common/LookUpList/DataList';
const CircularProgressSize = 18;
const ParkedReceiptsList = (props: IParkedReceiptsProps) => {
    const {
        classes,
        isLoading,
        keyField,
        listItems,
        disabled,
        fieldsToDisplay,
        handleRecordChange
    } = props;

    const [selectedRecord, setSelectedRecord] = React.useState(null);
    const onRecordChange = (record: any) => {
        setSelectedRecord(record);
        if (handleRecordChange) {
            handleRecordChange(record);
        }
    };

    return (
        <>
            {isLoading ?
                <CircularProgress size={CircularProgressSize} style={inlineStyles.preLoader} color={'secondary'} variant={'indeterminate'} />
                :
                <div className={classes.parkedReceiptMain}>
                    <DataList
                        disableDefaultSelection
                        disableItemSelection={disabled}
                        keyField={keyField}
                        listItems={(listItems || [])}
                        selectedRecordId={selectedRecord}
                        fieldsToDisplay={fieldsToDisplay}
                        handleRecordChange={onRecordChange}
                    />
                </div>
            }
        </>
    );
};

export default withStyles(inlineStyles, { index: 1 })(ParkedReceiptsList);
